import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { ThemeService } from "../../_helpers/theming-engine/theme.service";
import { TimelineSectionStudentInfo } from "../../_models/timeline-models/timeline-section-student-info.model";
import { SubjectsService } from "../../_services/shared/subjects.service";

@Component({
    templateUrl: 'select-timeline-subject.component.html',
    selector: 'select-timeline-subject',
    styleUrls: ['./select-timeline-subject.component.css'],
    standalone: false
})
export class SelectTimelineSubjectComponent implements OnInit {
  @Input() public subjects: string[] = [];
  @Input() public studentId: number;
  @Input() public placementId: number;
  @Input() public clientId: number;
  @Input() public studentName: string;
  @Output() public closeModal = new EventEmitter();

  constructor(
    private readonly subjectsService: SubjectsService, 
    private readonly router: Router,
    public themeService: ThemeService) {

  }

  ngOnInit(): void {
    this.subjectsService.getStudentSubjects(this.studentId).subscribe(data => {
      this.subjects = data.map(s => s.text);
    });
  }

  openTimeline(subject: string): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/timeline', this.placementId], {
        state: {
          placementId: this.placementId,
          timelineStudent: new TimelineSectionStudentInfo(this.studentId, this.studentName),
          studentName: this.studentName,
          subject: subject,
          clientId: this.clientId
        }
      })
    );
    this.closeModal.emit();
  }
}
